import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { VersionCheckService } from '../../services/version-check.service';

@Component({
  selector: 'app-update',
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule],
  templateUrl: './app-update.component.html',
  styleUrl: './app-update.component.css'
})
export class AppUpdateComponent {
  private versionService = inject(VersionCheckService);
  updateData = this.versionService.updateAvailable;

  reload() {
    this.versionService.commitUpdate();
    window.location.reload();
  }
}
